export const  AFN_VISIBILITY_RATELIMITTING_CONFIG = {
        apiName : `AFN page`,
        maxAllowedCalls: 150,
        durationWindowInSeconds:60,
}